var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	43575: {
		fallback: () => (Promise.all([__webpack_require__.e(5120), __webpack_require__.e(6382)]).then(() => (() => (__webpack_require__(4001))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",

	},
	53712: {
		fallback: () => (__webpack_require__.e(4301).then(() => (() => (__webpack_require__(54301))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <21.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	56769: {
		fallback: () => (__webpack_require__.e(3921).then(() => (() => (__webpack_require__(76302))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/styled",

	},
	95142: {
		fallback: () => (__webpack_require__.e(3854).then(() => (() => (__webpack_require__(61473))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <21.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	51519: {
		fallback: () => (__webpack_require__.e(4521).then(() => (() => (__webpack_require__(64521))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <21.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	97043: {
		fallback: () => (Promise.all([__webpack_require__.e(6772), __webpack_require__.e(3714), __webpack_require__.e(229), __webpack_require__.e(5955), __webpack_require__.e(6083), __webpack_require__.e(563), __webpack_require__.e(5120), __webpack_require__.e(5889), __webpack_require__.e(408), __webpack_require__.e(3575), __webpack_require__.e(6769), __webpack_require__.e(5142)]).then(() => (() => (__webpack_require__(90408))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=5.0.0 <10.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mui/material",

	},
	49934: {
		fallback: () => (Promise.all([__webpack_require__.e(1036), __webpack_require__.e(5142)]).then(() => (() => (__webpack_require__(91036))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "notistack",

	},
	3415: {
		fallback: () => (__webpack_require__.e(2921).then(() => (() => (__webpack_require__(52921))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=6.0.0 <8.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	45584: {
		fallback: () => (__webpack_require__.e(6895).then(() => (() => (__webpack_require__(56895))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <21.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-dev-runtime",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"1519": [
		51519
	],
	"1863": [
		97043,
		49934,
		3415
	],
	"3575": [
		43575
	],
	"3712": [
		53712
	],
	"5142": [
		95142
	],
	"5584": [
		45584
	],
	"6769": [
		56769
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}